import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import {
    SvgIconGrupoCoberturaSeguroVidaMorte,
    SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
    SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
    SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
    SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
    SvgIconGrupoCoberturaSeguroVidaFuneral,
    SvgIconGrupoCoberturaSeguroVidaAssistencia,
} from '../../../business-components/SvgIcon/SvgIconSeguroVida/SvgIconSeguroVida'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    grupoCoberturaSeguroVida1aParteList,
    grupoCoberturaSeguroVida2aParteList,
} from '../../../business-rules/List/SeguroVida/grupoCoberturaSeguroVidaList'

 import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import SeguroVidaCotacaoFormCotacao from './SeguroVidaCotacaoFormCotacao'

import {
    processaRegistrosDefaultIniciaisSeguroVidaCotacao,
//    calculaTotaisSeguroVidaCotacao,
} from './SeguroVidaCotacaoService'



const SeguroVidaCotacaoForm = ({ variaveisGlobais, values, handleChange, setFieldValue, popupCotacao }) => {

    const stepsSvgIcon = [
        SvgIconGrupoCoberturaSeguroVidaMorte,
        SvgIconGrupoCoberturaSeguroVidaInvalidezAcidente,
        SvgIconGrupoCoberturaSeguroVidaInvalidezDoenca,
        SvgIconGrupoCoberturaSeguroVidaDoencasGraves,
        SvgIconGrupoCoberturaSeguroVidaIncapacidadeTemporaria,
        SvgIconGrupoCoberturaSeguroVidaFuneral,
        SvgIconGrupoCoberturaSeguroVidaAssistencia,
    ]

    let steps = []

    grupoCoberturaSeguroVida1aParteList?.forEach( (linhaGrupoCoberturaSeguroVida1aParteList, index) => {
        
        steps.push(linhaGrupoCoberturaSeguroVida1aParteList)
    })

    steps[0] = LABEL.morteAcidental

    const stepsTitle2 = grupoCoberturaSeguroVida2aParteList

    const stepsContent = [
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <SeguroVidaCotacaoFormCotacao
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
    ]

    const valuesStepsTitle2 = [
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
        LABEL.valorPremio,
    ]

    //calculaTotaisSeguroVidaCotacao(values)

    return (
        <>
            <PanelRadioGroup
                name="familiarSeguroVidaCotacao"
                value={Number.parseInt(values.familiarSeguroVidaCotacao) || ''}
                onChange={(e) => {
                    handleChange(e)
                }}
                list={values.totalSeguroVidaCotacao}
                onBlur={
                    processaRegistrosDefaultIniciaisSeguroVidaCotacao(values,
                        Number.parseInt(values.familiarSeguroVidaCotacao))
                }
                helpText={HELPTEXT.seguroVidaCotacaoPanelRadioGroup}
            />

            {popupCotacao
                ?
                    <SeguroVidaCotacaoFormCotacao
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        popupCotacao={popupCotacao}
                    />
                :
                    <StepperPadrao
                        stepsType={"cardValor"}
                        stepsSvgIcon={stepsSvgIcon}
                        steps={steps}
                        stepsTitle2={stepsTitle2}
                        stepsContent={stepsContent}
                        valuesStep={values.stepSeguroVidaCotacao}
                        valuesStepsValor={values.stepsValorSeguroVidaCotacao}
                        valuesStepsTitle2={valuesStepsTitle2}
                        valuesStepsValor2={values.stepsValor2SeguroVidaCotacao}
                        naoPermiteConcluir={true}
                    />
            }
        </>
    )
}

export default SeguroVidaCotacaoForm